import React, { useEffect } from "react";
import { useMiniGameAuth } from "@pages/Events/MiniGame/store";
import ComponentInvite from "./ComponentInvite";

export default function InviteUser() {
  const { isAuthenticated, requireLogin } = useMiniGameAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      requireLogin();
    }
  }, [isAuthenticated, requireLogin]);

  if (!isAuthenticated) {
    return null;
  }

  return <ComponentInvite />;
}
